// src/config.js
// Application configuration constants

/**
 * Base URL for API requests
 * Uses environment variable in production, defaults to localhost in development
 */
// Environment-aware API URL selection
const isLocalDevelopment = window.location.hostname === 'localhost' ||
                          window.location.hostname === '127.0.0.1' ||
                          window.location.hostname.includes('localhost');

const getApiBaseUrl = () => {
  // Check for Fabric backend toggle
  const useFabric = process.env.REACT_APP_USE_FABRIC === 'true';
  
  // Check if we have an environment variable
  const envApiUrl = process.env.REACT_APP_API_BASE_URL;
  
  // If we're in cloud deployment but env var points to localhost, ignore it
  if (!isLocalDevelopment && envApiUrl && envApiUrl.includes('localhost')) {
    return 'https://moneyball-backend-280336112245.us-central1.run.app/api';
  }
  
  // Allow environment variable override for valid URLs
  if (envApiUrl) {
    return envApiUrl;
  }
  
  // Auto-detect based on hostname and backend preference
  if (isLocalDevelopment) {
    // Switch between MongoDB (port 5000) and Fabric (port 5001) backends
    return useFabric 
      ? 'http://localhost:5001/api'  // Fabric backend
      : 'http://localhost:5000/api'; // MongoDB backend (default)
  } else {
    return 'https://moneyball-backend-280336112245.us-central1.run.app/api';
  }
};

export const API_BASE_URL = getApiBaseUrl();

// Backend information for debugging and display
export const BACKEND_INFO = {
  type: process.env.REACT_APP_USE_FABRIC === 'true' ? 'Fabric' : 'MongoDB',
  url: API_BASE_URL,
  isLocal: isLocalDevelopment,
  useFabric: process.env.REACT_APP_USE_FABRIC === 'true'
};

/**
 * Maximum number of cards allowed in the workspace
 */
export const MAX_CARDS = 15;

/**
 * Default pagination settings
 */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Feature flags
 */
export const FEATURES = {
  enableAISearch: true,
  enableSuggestions: true,
  enableInsights: true,
  enableCardCollections: false, // Upcoming feature
};

/**
 * Debug settings
 */
export const DEBUG = {
  logAPIRequests: process.env.NODE_ENV === 'development',
  showGridLines: process.env.REACT_APP_SHOW_GRID_LINES === 'true',
};
